import { Color, ImageryLayer, Material, OpenStreetMapImageryProvider, Viewer, DirectionalLight, Cartesian3 } from "cesium";
import { DialogGeneral } from "../utils/Dialog/dialog";
import { createUUID, handleWindowResizeBySelector, watchElementBySelector } from "../utils/utils";
import '../styles/mapWeather.css'
import { IconArrowDown, IconSave } from "../icon";
import { Daylight } from "./mapWeather/daylight";
import { getMessage } from "../language";
import { MapTerrain } from "./mapWeather/mapTerrain";
import { IMapLayer, EMapLayerType, IObjMap, IObjInputMap, IObjInputDaylight, IInputSetMap } from "../interfaces/map.interface";
import { EMapUrl } from "../enums/map.enum";
import NONE_MAP from '../../src/assets/images/none_map.png'
import ROAD_MAP from '../../src/assets/images/road_map.png'
import SATELLITE_MAP from '../../src/assets/images/satellite_map.png'
export class MapWheater {
    viewer: Viewer;
    containerId: string;
    IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạ
    modal: any
    dialog: DialogGeneral | undefined;
    private _mapTerrain: MapTerrain | undefined
    dayLight: Daylight | undefined
    private objsNoneMap: IObjMap = {}
    private _originalMaterialDefault: Material | undefined;
    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean, typeMap: string) => void) | undefined;
    callbackMap: ((data: any) => void) | undefined;
    private mapOptions: IMapLayer[] = [
        {
            id: "map-road",
            name: EMapLayerType.Road,  // Sử dụng enum
            imgUrl: ROAD_MAP,
            urlMap: EMapUrl.Road
        },
        {
            id: "map-satellite",
            name: EMapLayerType.Satellite,  // Sử dụng enum
            imgUrl: SATELLITE_MAP,
            urlMap: EMapUrl.Satellite
        },
        {
            id: "map-none",
            name: EMapLayerType.None,  // Sử dụng enum
            imgUrl: NONE_MAP,
            urlMap: undefined
        }
    ];
    selectedMap: IMapLayer = this.mapOptions[0];


    constructor(containerId: string, viewer: any, isNoneMap?: boolean) {

        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        // this.loadImageryLayerUrl("https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga")
        if (isNoneMap) {
            this.selectedMap = this.mapOptions[2]
            this.loadImageryLayerUrl(this.mapOptions[2].urlMap!)
        } else {
            this.loadImageryLayerUrl(this.mapOptions[0].urlMap!)

        }


        this._mapTerrain = new MapTerrain({
            viewer: this.viewer, containerId: this.containerId
        })
        this.dayLight = new Daylight(
            this.viewer, this.containerId
        )
        this.createModalMapWeather()
        // this.addDropdownToggleEvent()

        this.showHideModalMapWeather(false)

        // Thiết lập màu ánh sáng môi trường (ambientColor) để các vùng khuất bóng/vùng tối của mô hình 3D luôn sáng rõ ở mọi bản đồ
        if (this.viewer.scene) {
            (this.viewer.scene as any).ambientColor = new Color(0.75, 0.75, 0.75, 1.0);
        }

        // Lắng nghe sự kiện preRender để cập nhật hướng nguồn sáng theo Camera (headlight)
        this.viewer.scene.preRender.addEventListener(() => {
            if (this.viewer.scene.light instanceof DirectionalLight) {
                Cartesian3.clone(this.viewer.camera.direction, this.viewer.scene.light.direction);
            }
        });
    }

    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean, typeMap: string) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean, typeMap: string): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status, typeMap); // Thông báo cho lớp cha
            if (!status) {
                this.removeDropdownToggleEvent()

            }
        } else {
            console.error("State change callback is not set.");
        }
    }

    //#region  createModalMapWeather
    createModalMapWeather = () => {

        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.IdGenneral = this.IdGenneral
        this.dialog.innerHeader = getMessage('map-title-dialog');
        this.dialog.modal = false
        this.dialog.minimizeDialog = true;

        this.dialog.topModal = "105px"
        this.dialog.rightModal = "45px"

        this.dialog.widthModal = "300px"
        this.dialog.heightModal = "auto"

        this.dialog.enableResize = false;
        this.dialog.allowDragging = false;
        this.dialog.fixedPosition = true;
        this.dialog.innerBody = this.renderMapWeatherData();
        this.dialog.innerFooter = this.renderFooter();

        this.dialog.createDialog();

        watchElementBySelector(`#${this.containerId}`, ({ width, height }) => {

            this._checkPositionDialog(width, height)

        })
        window.addEventListener('resize', () => {

            handleWindowResizeBySelector(`#${this.containerId}`, ({ width, height }) => {
                this._checkPositionDialog(width, height)
            })
        })

        //Gọi hàm xử lý Daylight
        this.dayLight!.handleDaylight(this.IdGenneral)
        //Gọi hàm xử lý Terrain
        this._mapTerrain?.createActionMapTerrain()


        this.viewer.scene.skyBox.show = false
        this.viewer.scene.globe.translucency.enabled = true

        this.viewer.scene.backgroundColor = Color.WHITE
        this.viewer.scene.globe.baseColor = Color.WHITE
        // this._inputMapTerrain.viewer.scene.globe.enableLighting = false;
        this.viewer.scene.globe.undergroundColor = Color.AZURE
        this.viewer.scene.globe.translucency.backFaceAlpha = Number(0.1)

        this._originalMaterialDefault = this.viewer.scene.globe.material;

        this.objsNoneMap = {
            skyBox: this.viewer.scene.skyBox.show,
            backgroundColor: this.viewer.scene.backgroundColor,
            frontFaceAlpha: this.viewer.scene.globe.translucency.frontFaceAlpha,
            globeBaseColor: this.viewer.scene.globe.baseColor,
            translucencyEnabled: this.viewer.scene.globe.translucency.enabled,
            undergroundColor: this.viewer.scene.globe.undergroundColor,
            backFaceAlpha: this.viewer.scene.globe.translucency.backFaceAlpha,
            globeMaterial: undefined
        }


        //Gọi hàm theo dỗi tắt bật background trắng
        this.viewer.clock.onTick.addEventListener((clock: any) => {
            const heightCamera = this.viewer.camera.positionCartographic.height;
            if (heightCamera > 50000) {
                this.viewer.scene.skyBox.show = true

            } else {
                this.viewer.scene.skyBox.show = false
            }

        })
    }




    showHideModalMapWeather = (show: boolean) => {
        // if (!this.isCreated) {
        //     this.createModalMapWeather()
        //     this.isCreated = true;
        // } else {
        //     if (show) {
        //         this.addDropdownToggleEvent()
        //     } else {
        //         this.removeDropdownToggleEvent()
        //     }
        //     this.dialog?.showModal(show)

        // }

        if (show) {
            this.addDropdownToggleEvent()

        } else {
            this.removeDropdownToggleEvent()
        }
        this.dialog?.showModal(show)
    }
    private _tempPosition = {
        top: '',
        left: '',
        right: '',
        bottom: '',
    };
    //#region renderFooter
    private containerFooter: HTMLElement | undefined
    renderFooter = (): HTMLElement => {
        if (!this.containerFooter) {
            this.containerFooter = document.createElement('div');
            this.containerFooter.id = `footer-tree-folder-${this.containerId}`;

        } else {
            this.containerFooter.style.margin = '10px 0';
            const settingBtn = document.createElement('button');
            settingBtn.id = `btn-move-model-${this.IdGenneral}`;
            settingBtn.className = 'DPU-btn-defaut-style';
            settingBtn.style.marginRight = '5px';
            settingBtn.innerHTML = IconSave()
            this.containerFooter.appendChild(settingBtn)

            if (settingBtn) {
                settingBtn.addEventListener('click', () => {
                    const obj = this.getObjMap()
                    this.triggerChange({
                        action: 'save',
                        data: obj
                    });
                });
            }

        }
        // this.containerFooter = document.createElement('div');
        // this.containerFooter.id = `footer-tree-folder-${this.containerId}`;



        return this.containerFooter;
    }

    triggerChange = (data: any) => {
        if (this.callbackMap) {
            this.callbackMap(data);
        }
    }

    private _checkPositionDialog = (width: number, height: number) => {
        const modalDialog = document.querySelector(`#modal-${this.IdGenneral}`) as HTMLElement;
        const dropdownContent = modalDialog?.querySelector('.dpu-dropdown-content-map-cesium') as HTMLElement;
        if (!modalDialog || !dropdownContent) {

            return;
        }

        // Hàm lấy giá trị inline style
        const getInlineStyleValue = (
            element: HTMLElement,
            property: keyof CSSStyleDeclaration
        ): string | null => {
            const value = element.style[property] as string | null; // Ép kiểu
            return value || null; // Trả về giá trị hoặc null nếu không có
        };

        if (height <= 400) {
            // Kiểm tra nếu `_tempPosition` chưa lưu giá trị
            const isTempPositionValid = Object.values(this._tempPosition).every(pos => pos === '');
            if (isTempPositionValid) {
                // Lưu các giá trị hiện tại từ inline styles
                this._tempPosition.top = getInlineStyleValue(modalDialog, 'top') || 'auto';
                this._tempPosition.left = getInlineStyleValue(modalDialog, 'left') || 'auto';
                this._tempPosition.right = getInlineStyleValue(modalDialog, 'right') || 'auto';
                this._tempPosition.bottom = getInlineStyleValue(modalDialog, 'bottom') || 'auto';

            }

            // Thay đổi vị trí modalDialog
            modalDialog.style.transform = 'translate(-50%)'
            modalDialog.style.bottom = '65px';
            modalDialog.style.left = '50%';
            // modalDialog.style.removeProperty('left');
            modalDialog.style.removeProperty('right');
            modalDialog.style.removeProperty('top');

            // Thay đổi dropdownContent
            dropdownContent.style.top = '-55px';
        } else if (height <= 550) {
            // Thay đổi dropdownContent
            dropdownContent.style.maxHeight = '85px';
        } else {

            // Kiểm tra nếu `_tempPosition` đã có giá trị để khôi phục
            const isTempPositionValid = Object.values(this._tempPosition).every(pos => pos !== '');
            if (isTempPositionValid) {
                // Khôi phục vị trí modalDialog
                modalDialog.style.top = this._tempPosition.top;
                modalDialog.style.left = this._tempPosition.left;
                modalDialog.style.right = this._tempPosition.right;
                modalDialog.style.bottom = this._tempPosition.bottom;
                modalDialog.style.removeProperty('transform');

                // Khôi phục dropdownContent
                dropdownContent.style.removeProperty('max-height');
                dropdownContent.style.removeProperty('top');
            }
        }
    };

    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status, this.selectedMap.name!)
        }
    }
    //#region  renderMapWeatherData
    private containerDiv: HTMLDivElement | undefined
    // Hàm renderMapWeatherData (hiển thị bản đồ đã chọn)
    private renderMapWeatherData = () => {
        // Kiểm tra xem containerDiv đã tồn tại hay chưa
        if (this.containerDiv) {
            this.clearContainer()
        } else {
            this.containerDiv = document.createElement('div')

            this.containerDiv.className = 'dpu-map-dropdown-container';
        }

        // Tạo nội dung HTML cho dropdown
        let dropdownContentHtml = '';

        // Duyệt qua mapOptions và tạo các phần tử cho dropdown
        this.mapOptions.forEach((map) => {
            // Đánh dấu map được chọn
            const isActive = this.selectedMap.name === map.name ? 'active' : '';

            // Tạo phần tử cho từng bản đồ
            dropdownContentHtml += `
            <div class="dpu-dropdown-content-child-container ${isActive}" data-id="${map.id}">
                <div class="container-img">
                    <img src="${map.imgUrl}" />
                </div>
                <div class="name-map">${map.name}</div>
            </div>
        `;
        });

        // Tạo HTML để hiển thị bản đồ đã chọn
        const contentHtml = `
        <div class="dpu-dropdown-map-cesium">
    
         <button class="dpu-dropbtn-map-cesium">
             <img src="${this.selectedMap.imgUrl}" />
             <div class="dropbtn-text-map-cesium">${this.selectedMap.name}</div>
             <div class="dropbtn-icon">${IconArrowDown()}</div>
         </button>
    
    
         <div class="dpu-dropdown-content-map-cesium">
            ${dropdownContentHtml}
         </div>
    
    </div>

    ${this._mapTerrain?.createDataMapTerrain()}

    ${this.dayLight!.rangeTimeCesium(this.IdGenneral)}
    `;

        // Set the inner HTML of the container
        this.containerDiv.innerHTML = contentHtml;
        // Gán sự kiện click cho tất cả các phần tử trong dropdown
        const mapItems = this.containerDiv.querySelectorAll('.dpu-dropdown-content-child-container');
        mapItems.forEach((item: any) => {
            item.addEventListener('click', (event: any) => {
                // Lấy mapId và đảm bảo nó là kiểu string hoặc null
                const mapId = (event.target as HTMLElement)
                    .closest('.dpu-dropdown-content-child-container')?.getAttribute('data-id') ?? null;

                // Gọi hàm selectMap với mapId
                if (mapId !== null) {
                    this.selectMap(mapId);
                } else {
                    console.error("Không tìm thấy data-id");
                }
            });
        });

        this.addDropdownToggleEvent();


        return this.containerDiv;
    };

    // Biến lưu tham chiếu đến handler
    private dropdownClickHandler: ((event: Event) => void) | null = null;
    //#region selectMap
    // Hàm xử lý khi người dùng chọn bản đồ từ dropdown
    private selectMap = (mapId: string | null) => {
        if (!mapId) return;

        const selectedMap = this.mapOptions.find(map => map.id === mapId);
        if (selectedMap) {
            if (this.selectedMap.id != selectedMap.id) {
                this.selectedMap = selectedMap;

                this.clearContainer()
                this.renderMapWeatherData(); // Cập nhật lại giao diện với bản đồ mới

                // 1. Tải bản đồ hình ảnh và khôi phục nguồn sáng mặc định trước
                this.loadImageryLayerUrl(selectedMap.urlMap!)

                // 2. Gọi lại hàm xử lý Terrain
                this._mapTerrain!.createActionMapTerrain()

                // 3. Gọi hàm xử lý Daylight với nguồn sáng đã được đồng bộ
                if (this.selectedMap.name === 'None') {
                    this.dayLight!.setNoneMapDayLight(true)
                    this._mapTerrain!.handleActionNoneMap(true)
                }
                else {
                    this.dayLight!.setNoneMapDayLight(false);
                }
                this.dayLight!.handleDaylight(this.IdGenneral)

                this.notifyCallBack(true, this.selectedMap.name!)
            }
        }
    };



    private clearContainer = () => {
        if (this.containerDiv) {
            while (this.containerDiv.firstChild) {
                this.containerDiv.removeChild(this.containerDiv.firstChild);
            }
        }
    }

    // Hàm thêm sự kiện click
    private addDropdownToggleEvent = () => {
        const dropdown = this.containerDiv!.querySelector('.dpu-dropdown-map-cesium');

        if (!dropdown) return;

        // Gỡ nếu đã có trước đó (rất quan trọng)
        if (this.dropdownClickHandler) {
            dropdown.removeEventListener('click', this.dropdownClickHandler);
        }
        document.removeEventListener('click', this.handleOutsideClick);
        // Lưu hàm xử lý sự kiện vào biến để có thể hủy sau này
        this.dropdownClickHandler = (event: Event) => {
            event.stopPropagation(); // Ngăn sự kiện lan tới document

            dropdown.classList.add('active');
        };

        // Gán sự kiện click
        dropdown.addEventListener('click', this.dropdownClickHandler);

        // Sự kiện click bên ngoài để tắt dropdown
        document.addEventListener('click', this.handleOutsideClick);
    };

    // Hàm hủy sự kiện click
    private removeDropdownToggleEvent = () => {
        const dropdown = this.containerDiv!.querySelector('.dpu-dropdown-map-cesium');
        if (!dropdown || !this.dropdownClickHandler) return;

        // Hủy sự kiện click trong dropdown
        dropdown.removeEventListener('click', this.dropdownClickHandler);

        // Hủy sự kiện click bên ngoài
        document.removeEventListener('click', this.handleOutsideClick);

        // Xóa handler để tránh rò rỉ bộ nhớ
        this.dropdownClickHandler = null;
    };

    // Hàm xử lý sự kiện click bên ngoài
    private handleOutsideClick = (event: Event) => {
        const dropdown = this.containerDiv!.querySelector('.dpu-dropdown-map-cesium');
        if (dropdown && !dropdown.contains(event.target as Node)) {
            dropdown.classList.remove('active');
        }
    };

    private isNoneMap = false
    //Load Img cho đường
    private loadImageryLayerUrl = (url: string) => {
        if (url != undefined) {
            let findUrl = false;
            (this.viewer.scene.imageryLayers as any)._layers.forEach((layer: ImageryLayer) => {
                layer.show = false
                const provider = layer.imageryProvider;
                if (provider instanceof OpenStreetMapImageryProvider) {
                    const urlFix = url + "/{z}/{x}/{y}.png"
                    if (provider.url === urlFix) {
                        layer.show = true
                        findUrl = true
                    }
                }
            })
            if (!findUrl) {
                const layer = new ImageryLayer(new OpenStreetMapImageryProvider({
                    maximumLevel: 22,
                    url: url
                }));
                layer.show = true;
                this.viewer.scene.imageryLayers.add(layer);

            }
            if (this.isNoneMap) {
                this.toggleNoneMap(true)
            }
        } else {
            this.isNoneMap = true;
            this.objsNoneMap.globeMaterial = this.viewer.scene.globe.material
            this.objsNoneMap.frontFaceAlpha = this.viewer.scene.globe.translucency.frontFaceAlpha
            this.toggleNoneMap(false)
            return
        }
    }


    private toggleNoneMap = (showMap: boolean) => {
        if (showMap) {
            this.isNoneMap = false;
            this.viewer.scene.globe.show = true; // Hiện lại quả địa cầu để camera hoạt động bình thường

            // Thiết lập nguồn sáng hướng theo hướng Camera (headlight) với cường độ 2.5 để vật luôn sáng
            this.viewer.scene.light = new DirectionalLight({
                direction: Cartesian3.clone(this.viewer.camera.direction),
                intensity: 2.5
            });

            // Tắt hiệu ứng ánh sáng trên địa hình để bản đồ địa hình (Road/Satellite) luôn sáng rõ, không bị tối màu
            this.viewer.scene.globe.enableLighting = false;

            if (this.objsNoneMap) {
                this.viewer.scene.globe.material = this._originalMaterialDefault
                this.viewer.scene.backgroundColor = new Color(this.objsNoneMap.backgroundColor!.red, this.objsNoneMap.backgroundColor!.green, this.objsNoneMap.backgroundColor!.blue, this.objsNoneMap.backgroundColor!.alpha || 1.0);
                this.viewer.scene.skyBox.show = this.objsNoneMap.skyBox!
                this.viewer.scene.globe.translucency.enabled = this.objsNoneMap.translucencyEnabled!
                this.viewer.scene.globe.baseColor = new Color(this.objsNoneMap.globeBaseColor!.red, this.objsNoneMap.globeBaseColor!.green, this.objsNoneMap.globeBaseColor!.blue, this.objsNoneMap.globeBaseColor!.alpha || 1.0);
                this.viewer.scene.globe.undergroundColor = new Color(this.objsNoneMap.undergroundColor!.red, this.objsNoneMap.undergroundColor!.green, this.objsNoneMap.undergroundColor!.blue, this.objsNoneMap.undergroundColor!.alpha || 1.0);
                this.viewer.scene.globe.translucency.frontFaceAlpha = this.objsNoneMap.frontFaceAlpha!
                // this.viewer.scene.globe.translucency.backFaceAlpha = this.objsNoneMap.backFaceAlpha!
                // console.log(this.viewer.scene.globe);
                // this.viewer.scene.globe.material = undefined;
            }

            const containerId = document.querySelector(`#${this.containerId}`)
            const canvas = containerId?.querySelector('canvas')
            canvas!.style.setProperty('background', 'unset');
            const footerInfoElements = containerId?.querySelectorAll(`.footer-info-content`);
            // Ẩn tất cả trừ phần tử đầu tiên
            if (footerInfoElements) {
                footerInfoElements.forEach((element, index) => {
                    const htmlElement = element as HTMLElement; // Ép kiểu
                    if (index !== 0) {
                        htmlElement.style.removeProperty('display'); // Xóa thuộc tính display
                    }
                });
            }


        } else {
            this.viewer.scene.globe.show = false; // Ẩn hoàn toàn quả địa cầu. Khi quả địa cầu ẩn, camera controller sẽ tự động chuyển tiêu điểm (pivot focus) lên các 3D Tiles/BIM Model trong Scene thay vì bị trôi vô cực!

            // Thiết lập nguồn sáng hướng theo hướng Camera (headlight) với cường độ mạnh để các mô hình 3D luôn sáng rõ từ mọi góc nhìn
            this.viewer.scene.light = new DirectionalLight({
                direction: Cartesian3.clone(this.viewer.camera.direction),
                intensity: 2.5
            });

            this.viewer.scene.backgroundColor = Color.TRANSPARENT;
            this.viewer.scene.globe.baseColor = Color.TRANSPARENT;
            this.viewer.scene.globe.undergroundColor = Color.TRANSPARENT;
            this.viewer.scene.globe.translucency.enabled = true

            this.viewer.scene.globe.material = undefined
            this.viewer.scene.globe.translucency.frontFaceAlpha = Number(0.0)

            // Loại bỏ tất cả các lớp hình ảnh nếu có
            this.viewer.imageryLayers.removeAll();

            const containerId = document.querySelector(`#${this.containerId}`)
            const canvas = containerId?.querySelector('canvas')
            canvas!.style.setProperty('background', 'linear-gradient(to bottom, #87CEFA, #ffffff)', 'important');

            const footerInfoElements = containerId?.querySelectorAll(`.footer-info-content`);
            // Ẩn tất cả trừ phần tử đầu tiên
            if (footerInfoElements) {
                footerInfoElements.forEach((element, index) => {
                    const htmlElement = element as HTMLElement; // Ép kiểu
                    if (index !== 0) {
                        htmlElement.style.display = 'none'; // Ẩn các phần tử trừ phần tử đầu
                    }
                });
            }
        }
        // Tạo mặt phẳng giả 

        // Ẩn quả địa cầu      
        this.viewer.scene.screenSpaceCameraController.enableCollisionDetection = showMap // Bật Camera có thể xem được dưới trái đất vật
        this.viewer.scene.skyAtmosphere.show = showMap; // Ẩn khí quyển
        this.viewer.scene.skyBox.show = showMap;        // Ẩn bầu trời
        this.viewer.scene.moon.show = showMap;          // Ẩn mặt trăng
        this.viewer.scene.sun.show = showMap;              // Ẩn mặt trời hoàn toàn khi ở bản đồ None để không nhìn thấy đĩa mặt trời


        this.viewer.scene.requestRender()
    }

    //#region getObjMap
    getObjMap = (): IObjInputMap => {

        const optionGloble: IObjMap = {
            skyBox: this.viewer.scene.skyBox.show,
            backgroundColor: this.viewer.scene.backgroundColor,
            frontFaceAlpha: this.viewer.scene.globe.translucency.frontFaceAlpha,
            globeBaseColor: this.viewer.scene.globe.baseColor,
            translucencyEnabled: this.viewer.scene.globe.translucency.enabled,
            undergroundColor: this.viewer.scene.globe.undergroundColor,
            backFaceAlpha: this.viewer.scene.globe.translucency.backFaceAlpha,
            globeMaterial: (this.viewer.scene.globe.material) ? true : false,

            checkDepth: this._mapTerrain!.checkboxDepth,
            checkTerrain: this._mapTerrain!.checkboxTerrain,
            valueTransparentGlobe: (this.viewer.scene.globe.material) ? this._mapTerrain!.valueTransparentGlobe : 0
        }
        const optionDayLight: IObjInputDaylight = {
            checkBox: this.dayLight!.checkBox,
            defautLight: this.dayLight!.defautLight,
            isNoneMapDaylight: this.dayLight!.isNoneMapDaylight,
            valueTime: this.dayLight!.valueTime,
            valueTimeSlider: this.dayLight!.valueTimeSlider

        }

        const objInputMap: IObjInputMap = {
            optionGloble: optionGloble,
            mapLayer: this.selectedMap,
            optionDayLight: optionDayLight

        }

        return objInputMap;
    }

    setObjMap = (objMap: IObjInputMap) => {
        this.objsNoneMap = { ...this.objsNoneMap, ...objMap.optionGloble }

        this._mapTerrain!.checkboxDepth = objMap.optionGloble!.checkDepth ?? this._mapTerrain!.checkboxDepth
        this._mapTerrain!.checkboxTerrain = objMap.optionGloble!.checkTerrain ?? this._mapTerrain!.checkboxTerrain
        this._mapTerrain!.valueTransparentGlobe = objMap.optionGloble?.valueTransparentGlobe ?? this._mapTerrain!.valueTransparentGlobe

        this.dayLight!.checkBox = objMap.optionDayLight?.checkBox ?? this.dayLight!.checkBox
        this.dayLight!.defautLight = objMap.optionDayLight?.defautLight ?? this.dayLight!.defautLight
        this.dayLight!.isNoneMapDaylight = objMap.optionDayLight?.isNoneMapDaylight ?? this.dayLight!.isNoneMapDaylight
        this.dayLight!.valueTime = objMap.optionDayLight?.valueTime ?? this.dayLight!.valueTime
        this.dayLight!.valueTimeSlider = objMap.optionDayLight?.valueTimeSlider ?? this.dayLight!.valueTimeSlider ?? this.dayLight!.valueTimeSlider

        const selectMap = this.mapOptions.find((item: IMapLayer) => item.name === objMap.mapLayer?.name)
        if (selectMap) {
            this.selectedMap = selectMap

        }
        this.loadImageryLayerUrl(this.selectedMap?.urlMap!)

        this.renderMapWeatherData();


        //Gọi hàm xử lý Daylight
        this.dayLight!.handleDaylight(this.IdGenneral)

        this.dayLight!.checkBoxForShadow(this.dayLight!.checkBox)

        //Gọi hàm xử lý Terrain
        this._mapTerrain?.createActionMapTerrain()
        if (this.selectedMap?.name === 'None') {
            this._mapTerrain!.handleActionNoneMap(true)
            this.dayLight!.setNoneMapDayLight(true)

        }
        //xử lý nếu như có value TransparentGlobe
        if (this._mapTerrain!.valueTransparentGlobe > 0) {
            this._mapTerrain!.actionTransparentGlobe(this._mapTerrain!.valueTransparentGlobe)
        }
        // this.selectMap(this.selectedMap!.id ?? null)
    }

    setInfoMap = (setMap: IInputSetMap) => {
        this._mapTerrain!.checkboxDepth = setMap.depthTerrain ?? this._mapTerrain!.checkboxDepth
        this._mapTerrain!.checkboxTerrain = setMap.terrain ?? this._mapTerrain!.checkboxTerrain
        this.dayLight!.checkBox = setMap.shadow ?? this.dayLight!.checkBox
        const selectMap = this.mapOptions.find((item: IMapLayer) => item.name === setMap.nameMap)
        if (selectMap) {
            this.selectedMap = selectMap
        }
        this.loadImageryLayerUrl(this.selectedMap?.urlMap!)

        this.renderMapWeatherData();

        //Gọi hàm xử lý Daylight
        this.dayLight!.handleDaylight(this.IdGenneral)
        this.dayLight!.checkBoxForShadow(this.dayLight!.checkBox)

        //Gọi hàm xử lý Terrain
        this._mapTerrain?.createActionMapTerrain()
        if (this.selectedMap?.name === 'None') {
            this._mapTerrain!.handleActionNoneMap(true)
            this.dayLight!.setNoneMapDayLight(true)

        }
        // this.selectMap(this.selectedMap!.id ?? null)

    }
}